import { render, staticRenderFns } from "./TreatmentSelect.vue?vue&type=template&id=6ee2bae8"
import script from "./TreatmentSelect.vue?vue&type=script&lang=js"
export * from "./TreatmentSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports